import Model, { attr } from '@ember-data/model';

export default class ContextualReplyModel extends Model {
  @attr('string') content!: string;
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'contextual-reply': ContextualReplyModel;
  }
}
